import styled from 'styled-components';

export const WrapperLegend = styled.div`
  display: flex;
  padding: 5px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  p {
    margin: 0 5px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
  path {
    fill: ${({ colorInfo }) => {
      return colorInfo;
    }};
  }
`;
